import { createSlice } from '@reduxjs/toolkit';
import { getCurrentCurrency, CURRENCIES, setCurrentCurrency } from '../../utils/currencyUtils';

const initialState = {
  currentCurrency: getCurrentCurrency(),
  currencies: CURRENCIES,
};

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    setCurrency: (state, action) => {
      const newCurrency = action.payload;
      state.currentCurrency = newCurrency;
      // Sync with localStorage
      setCurrentCurrency(newCurrency);
    },
    updateExchangeRates: (state, action) => {
      Object.keys(action.payload).forEach(code => {
        if (state.currencies[code]) {
          state.currencies[code].exchangeRate = action.payload[code];
        }
      });
    },
  },
});

export const { setCurrency, updateExchangeRates } = currencySlice.actions;
export default currencySlice.reducer; 